<template>
  <aside class="fill-grid-map-aside">
    <div class="toggle-button d-flex justify-content-center align-items-center" @click="hideAside">
      <i v-if="asideCollapsed" class="fas fa-caret-left"></i>
      <i v-else class="fas fa-caret-right"></i>
    </div>
    <div class="lists-container">
      <h4 style="padding: 0.5rem; margin: 0; position: sticky; top: 0; background-color: #eee; z-index: 2;">
        Estados de las tareas
      </h4>
      <FillGridMapAsideTaskList
        v-for="task in allTasks"
        :key="task.title"
        :tasks="task.tasks"
        :icon="task.icon"
        :iconColor="task.iconColor"
        :title="task.title"
        :idents="idents"
        :identsLabels="identsLabels"
        :selected-task-id="selectedTaskId"
        :collapsed="task.collapsed"
        @select-task="selectTask"
      />
    </div>
  </aside>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import FillGridMapAsideTaskList from './FillGridMapAsideTaskList.vue'

@Component({
  components: {
    FillGridMapAsideTaskList
  }
})
export default class FillGridMapAside extends Vue {
  @Prop({ required: true, default: () => [] })
  tasks: any[]

  @Prop({ required: true, default: () => [] })
  idents: string[]

  @Prop({ required: true, default: () => [] })
  identsLabels: string[]

  @Prop({ required: false, default: -1 })
  selectedTaskId: number

  asideCollapsed: boolean = false

  get allTasks () {
    return [
      {
        tasks: this.tasks.filter(task => task.locationType === 'planned'),
        icon: 'fa-clock',
        iconColor: '#495057',
        title: 'Planeadas'
      },
      {
        tasks: this.tasks.filter(task => task.locationType === 'visited'),
        icon: 'fa-check-circle',
        iconColor: '#28A745',
        title: 'Visitadas'
      },
      {
        tasks: this.tasks.filter(task => task.locationType === 'no-location'),
        icon: 'fa-exclamation-circle',
        iconColor: '#858585',
        title: 'Sin Ubicación',
        collapsed: true
      }
    ]
  }

  hideAside () {
    this.asideCollapsed = !this.asideCollapsed
    this.$emit('toggle-aside', this.asideCollapsed)
  }

  selectTask (task: any) {
    this.$emit('select-task', task)
  }
}
</script>

<style lang="scss" scoped>
.fill-grid-map-aside {
  position: relative;
  height: 100%;
  font-weight: 300;
  box-shadow: 0 0 12px #ccc;

  .lists-container {
    overflow-y: auto;
    max-height: 100%;
  }

}

.toggle-button {
  position: absolute;
  right: calc(100% + 2px);
  top: 3rem;
  width: 1.5rem;
  height: 2.5rem;
  background-color: var(--sidebar-bg-color);
  box-shadow: 1px 1px 3px #bbb;
  cursor: pointer;
}
</style>
